import React, { useState, useRef, useEffect } from 'react';
import SatFollowText from '@components/common/satUI/SatFollowText';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import SatButton from '@components/common/satUI/SatButton';

import { checkProduct, getPayInMethodLabel, toCurrency } from '@common/utils';

const PaymentInput = props => {
  const {
    planMainInfo,
    mainContractInfo,
    completePdfPage,
    onClickConfirmBtn,
    mainProductInfo,
  } = props;
  const followRef = useRef();
  const [isValid, setIsValid] = useState(false); // 따라쓰기 입력 여부
  const [isFollowTxtError, setIsFollowTxtError] = useState(false);

  const handleMatched = res => {
    if (res) {
      setIsValid(true);
      setIsFollowTxtError(false);
    }
  };

  const handleButtonClick = () => {
    if (!isValid) {
      setIsFollowTxtError(true);
      followRef.current.onFocusInput();
    } else {
      onClickConfirmBtn();
    }
  };

  useEffect(() => {
    if (completePdfPage.includes('988')) {
      setIsValid(true);
    } else {
      followRef.current.onFocusInput();
    }
  }, [completePdfPage]);

  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">보험료 납입기간 입력</h3>
      </header>
      <div className="cont modal-scroll-wrap">
        <p className="text-info4">
          아래의 입력 영역을 선택하여 키패드로 직접 입력해주세요.
        </p>
        <div className="txt-pad-wrap">
          {`주계약 및 특약보험료 : ${getPayInMethodLabel(
            planMainInfo.payinMethod,
          )} ${
            planMainInfo.currencyUsdYN === 'Y'
              ? !checkProduct(mainProductInfo, 'PaymentInput_productType')
                ? toCurrency(planMainInfo.premium, 2)
                : toCurrency(planMainInfo.premium)
              : toCurrency(planMainInfo.premium)
          } ${planMainInfo.currencyUsdYN === 'Y' ? '달러' : '원'} (${
            mainContractInfo.payinPeriodInfoLabel === '전기납' ? '전기납' : ''
          }`}
          {mainContractInfo.payinPeriodInfoLabel === '전기납' ? (
            <>
              {`(`}
              <SatFollowText
                ref={followRef}
                followText={`${mainContractInfo.coveragePeriodValue}세납`}
                onMatched={handleMatched}
                complete={completePdfPage.includes('988')}
              />
              {`)`}
            </>
          ) : (
            <SatFollowText
              ref={followRef}
              followText={mainContractInfo.payinPeriodInfoLabel}
              onMatched={handleMatched}
              complete={completePdfPage.includes('988')}
            />
          )}
          {`)`}
        </div>
        <SatValidationErrMsg
          visible={isFollowTxtError}
          type="error"
          message="내용을 확인하고 따라쓰기를 해주세요."
        />
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${!isValid ? 'disabled' : ''}`}
          label={'확인'}
          onClick={() => handleButtonClick()}
        />
      </div>
    </>
  );
};

export default PaymentInput;
